(function(win,doc){
  document.addEventListener("DOMContentLoaded", (event) => {
    var myswiper;

    function updatePlay(swiper){      
      if( window.myOnYouTubeIframeAPIReadyIs ){
        mystart(swiper);
      }else{
        document.addEventListener('myOnYouTubeIframeAPIReady',function(){
            mystart(swiper);
        });
      }
    }

    myswiper = new Swiper('.mySwiper', {
      loop: true,
      on: {
        init: function () {
          updatePlay(this);
          const currentSlide = this.slides[this.activeIndex];
          this.pagination.el.style['top'] = (currentSlide.offsetHeight + 5 )+'px';
        },
        beforeLoopFix: function(){
          this.slides.forEach(function(v){
            const currentSlideId = v.getAttribute('data-id');

            if (v.myplay) {
              if (v.myplay.pauseVideo) {
                v.myplay.pauseVideo();
              }
            }
          });
        },
        slideChangeTransitionEnd: function() {
          const currentSlide = this.slides[this.activeIndex];
          const currentSlideId = currentSlide.getAttribute('data-id');
          this.pagination.el.style['top'] = (currentSlide.offsetHeight + 5 )+'px';

          this.slides.forEach(function(v){
            if (v.myplay) {
              if (v == currentSlide) {
                if (v.myplay.seekTo) {
                  v.myplay.seekTo(0,true);
                }
                if (v.myplay.playVideo) {
                  v.myplay.playVideo();
                }
              }else{
                if (v.myplay.pauseVideo) {
                  v.myplay.pauseVideo();
                }
              }
            }
          });

          updatePlay(this);
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    function mystart(swiper){
        const currentSlide = swiper.slides[swiper.activeIndex];
        const currentSlideId = currentSlide.getAttribute('data-id');

        const video = currentSlide.querySelector('.nk-video');
        if (video) {
          var iframe = video.querySelector('iframe');
          if (iframe) {

          }else{
            var videoId = video.getAttribute('data-video-id');
            var myId = video.getAttribute('data-id');
            var player = new YT.Player(video.children[0], {
              videoId: videoId,
              playerVars: {
                autoplay: 1,
                loop: 1,
                rel : 0,
                controls: 1,
                disablekb: 0,
                mute : 1,
                modestbranding: 1
              },
              events: {
                'onReady': function(event){
                  event.target.mute();
                  currentSlide.myplay = player;
                },
                onStateChange: function(e) {
                  if (e.data === YT.PlayerState.ENDED) {
                    player.playVideo(); 
                  }
                }
              }
            });
          }
        }
    }
  });
}(window,document));